
import React         from 'react'
import FontAwesome   from 'react-fontawesome'
import { Input, Button, DatePicker, Select, Tooltip } from 'antd'

import './filter-account.scss'

const { Search }      = Input
const { RangePicker } = DatePicker
const { Option }      = Select

const regions = [
  'us-east-2',
  'us-east-1',
  'us-west-1',
  'us-west-2',
  'ca-central-1',
  'ap-south-1',
  'ap-northeast-2',
  'ap-southeast-1',
  'ap-southeast-2',
  'ap-northeast-1',
  'eu-central-1',
  'eu-west-1',
  'eu-west-2',
  'eu-west-3',
  'sa-east-1',
  'cn-north-1',
  'cn-northwest-1'
]

const accounts = [
  'aws',
  'wasabi',
  'azure'
]

export default ({
  expanded, filter, cost, usage,
  handleSearch, handleAccountChange, handleRegionChange,
  handleCreatedChange, handleCostChange, handleUsageChange,
  handleCostRangeChange, handleUsageRangeChange, on_show_compare
  }) => (
    <div>
    
      <div className='main-filter-account round-corner'>
        <div className='dropdown-group filter-by-type'>
        {/* <label></label> */}
          <Select
          defaultValue='all' size={'small'} dropdownMatchSelectWidth={false}
          onChange={handleAccountChange}>
            <Option value='all'>Filter by type</Option>
            {accounts.map((account, index) =>
            <Option key={index} value={account}>
            {account}
            </Option>
          )}
          </Select>
        </div>
      </div>

      {
        expanded &&
        <div className='expand-filter'>
          <div className='input-group'>
            <label>Search by bucket name</label>
            <div className="filter-area">
              <Search
                placeholder='Search...' size={'small'} value={filter.search}
                onChange={(e) => handleSearch(e.target.value)} />
            </div>
          </div>

          <div className='dropdown-group filter-by-type'>
            <label>Filter by type</label>
            <div className="filter-area">
              <Select
                defaultValue='all' size={'small'} dropdownMatchSelectWidth={false}
                onChange={handleAccountChange}>
                <Option value='all'>all</Option>
                {accounts.map((account, index) =>
                  <Option key={index} value={account}>
                    {account}
                  </Option>
                )}
              </Select>
            </div>
          </div>

          {/*<div className='slider filter-by-cost'>
            <label>Filter by cost ($)</label>
            <div>
              <span>{filter.cost.min}</span>
              <Slider
                range value={filter.cost.value ? filter.cost.value : 0}
                min={filter.cost.min ? filter.cost.min : 0} max={filter.cost.max ? filter.cost.max : 0}
                onChange={handleCostChange} onAfterChange={handleCostRangeChange} />
              <span>{filter.cost.max}</span>
            </div>
          </div>*/}
  
          {/*<div className='slider filter-by-usage'>
            <label>Filter by usage (GB)</label>
            <div>
              <span>{filter.usage.min}</span>
              <Slider
                range value={filter.usage.value ? filter.usage.value : 0}
                min={filter.usage.min ? filter.usage.min : 0} max={filter.usage.max ? filter.usage.max : 0}
                onChange={handleUsageChange} onAfterChange={handleUsageRangeChange}
              />
              <span>{filter.usage.max}</span>
            </div>
          </div>*/}
          <div className='range-picker filter-by-date'>
            <label>Filter by creation date</label>
            <div className="filter-area">
              <RangePicker
                format='MM/DD/YYYY'
                size={'small'}
                placeholder={['Start', 'End']}
                onChange={handleCreatedChange}
                className="date-time"
              />
            </div>
          </div>
          
          <div className='dropdown-group filter-by-region'>
            <label>Filter by region</label>
            <div className="filter-area">
              <Select
                defaultValue='all' size={'small'} dropdownMatchSelectWidth={false}
                onChange={handleRegionChange}>
                <Option value='all'>all</Option>
                {regions.map((region, index) =>
                  <Option key={index} value={region}>
                    {region}
                  </Option>
                )}
              </Select>
            </div>
          </div>

          {/*{
            !expanded &&
            <div className='compare'>
              <Tooltip title='Compare prices between cloud storage providers' placement={'left'}>
                <Button shape="circle" onClick={on_show_compare}><FontAwesome name='balance-scale'/></Button>
              </Tooltip>
            </div>
          }*/}
        </div>
      }

    </div>
  )
